export default "<div class=\"text-center py-5\">\n  <i class=\"far fa-check-circle fa-10x\"></i>\n</div>\n";